import React from 'react'

interface LogoProps {
  LogoImage: string
  alt?: string
  classes?: string
}

export default function Logo ({ LogoImage, alt = 'Tellus Logo', classes = 'mx-auto' }: LogoProps) {
  return (
    <img
      className={`${classes} h-12 sm:h-10 w-auto`}
      src={LogoImage}
      alt={alt}
    />
  )
}
